import Axios from 'axios';
import type { IFAQData } from '../../models/profile';
import { createStandardResponse, StandardResponse } from '../../models/standard-response';
import { env } from 'config/env';

export const getFAQData = async (): Promise<StandardResponse<IFAQData>> => {
  try {
    const res = await Axios.get(`${env.VITE_API_SERVER}/common/driver/public/information/faqs`);
    return createStandardResponse<IFAQData>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const getFleetFAQData = async (): Promise<StandardResponse<IFAQData>> => {
  try {
    const res = await Axios.get(`${env.VITE_API_SERVER}/common/fleet-driver/public/information/faqs`);
    return createStandardResponse<IFAQData>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};
